<template>
  <v-container v-if="loading">
    <div class="text-xs-center">
      <v-progress-circular
        indeterminate
        :size="150"
        :width="8">
      </v-progress-circular>
    </div>
  </v-container>

  <v-container v-else fluid grid-list-md>
    <v-layout column>
      <v-flex xs12 sm6 v-if="!isList" >
        <v-card>
          <grid-cards v-bind:recalls="recalls" v-bind:noData="noData" v-bind:isSearch="isSearch" v-bind:searchString="searchString"></grid-cards>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 v-else>
        <v-card>
          <list-cards v-bind:recalls="recalls" v-bind:noData="noData" v-bind:isSearch="isSearch" v-bind:searchString="searchString"></list-cards>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import recallApi from '@/services/RecallApi'

export default {
  name: 'RecallSearch',
  props: {
    name: String
  },

  created () {
    this.searchString = this.name
    window.bus.$on('emitListView', (args) => {
      this.isList = args.isList
    })
  },
  data () {
    return {
      recalls: [],
      show: false,
      isList: false,
      startDate: null,
      endDate: null,
      searchString: null,
      loading: true,
      noData: false,
      isSearch: true
    }
  },
  methods: {
    fetchRecallData () {
      // console.log('startDate=' + this.startDate + ',endDate=' + this.endDate + ',searchString=' + this.searchString)
      recallApi.fetchRecallCollection(this.startDate, this.endDate, this.searchString)
        .then(response => {
          if (Object.keys(response).length) {
            this.recalls = response.slice(0, 100)
            this.loading = false
            this.noData = false
          } else {
            this.noData = true
            this.loading = false
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
    }
  },
  mounted () {
    this.fetchRecallData()
  },
  watch: {
    name: {
      handler: function (newValue) {
        this.searchString = newValue
        this.fetchRecallData()
      }
    }
  }
}

</script>
